export default __webpack_public_path__ + "static/media/table-responsive-smaller-screens.c0ed1365.svg";